import { alpha, Stack, Typography } from "@mui/material";
import { signedFloat } from "~/pages/space/home-dashboard/SprintStreakCard/hooks/useSprintStreakCard";

export interface SprintStreakDeltaProps {
  riskDelta: number;
  type?: "axis" | "chart";
}

export function SprintStreakCardDelta({
  riskDelta,
  type = "axis",
}: SprintStreakDeltaProps) {
  const isRiskIncrease = riskDelta > 0;
  return (
    <Stack
      sx={{
        p: type === "chart" ? 2 : 0.5,
        px: type === "axis" ? 1 : undefined,
        borderRadius: 1,
        alignItems: "center",
        justifyContent: "center",
        height: "fit-content",
        background: (theme) =>
          alpha(theme.palette[isRiskIncrease ? "critical" : "none"].main, 0.1),
      }}
    >
      <Typography
        sx={{
          fontSize: type === "chart" ? 32 : 16,
          fontWeight: 700,
          lineHeight: "100%",
          color: isRiskIncrease ? "critical.main" : "none.main",
        }}
      >
        {signedFloat(riskDelta)}
      </Typography>
      {type === "chart" && (
        <Typography
          variant="caption"
          sx={{
            fontSize: 16,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          {"Δ SPACE RISK"}
        </Typography>
      )}
    </Stack>
  );
}
